<template>
    <v-container
        :fluid="content.fullWidth"
        :class="{
            'superhero-container': true,
        }"
    >
        <v-row column justify-center align-center no-gutters>
            <v-col cols="12" md="7">
                <div
                    id="sidekick1"
                    class="sidekick-wrapper"
                    :style="calcImageInlineStyle(image1)"
                >
                    <nuxt-link :to="calcTo(image1)" :class="`sidekick-link`">
                        <div
                            :class="`sidekick-inner overlay-light-blue ${image1.align}`"
                        >
                            <div class="sidekick-text">
                                <CtaLinks
                                    :links="image1.ctaLinks"
                                    layout="NoLink"
                                    :font="image1.ctaFont"
                                />
                            </div>
                        </div>
                    </nuxt-link>
                </div>
            </v-col>
            <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="12" md="5">
                <v-container fluid class="pa-0 citizen-container">
                    <v-row column justify-center align-center no-gutters>
                        <v-col cols="12" class="pl-4 pb-2">
                            <div
                                id="sidekick2"
                                class="sidekick-wrapper"
                                :style="calcImageInlineStyle(image2)"
                            >
                                <nuxt-link
                                    :to="calcTo(image2)"
                                    :class="`sidekick-link`"
                                >
                                    <div
                                        :class="`sidekick-inner overlay-light-blue ${image2.align}`"
                                    >
                                        <div class="sidekick-text">
                                            <CtaLinks
                                                :links="image2.ctaLinks"
                                                layout="NoLink"
                                            />
                                        </div>
                                    </div>
                                </nuxt-link>
                            </div>
                        </v-col>
                        <v-col cols="12" class="pl-4 pt-2">
                            <div
                                id="sidekick3"
                                class="sidekick-wrapper"
                                :style="calcImageInlineStyle(image3)"
                            >
                                <nuxt-link
                                    :to="calcTo(image3)"
                                    :class="`sidekick-link`"
                                >
                                    <div
                                        :class="`sidekick-inner overlay-light-blue ${image3.align}`"
                                    >
                                        <div class="sidekick-text">
                                            <CtaLinks
                                                :links="image3.ctaLinks"
                                                layout="NoLink"
                                            />
                                        </div>
                                    </div>
                                </nuxt-link>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <!-- <v-row>
            <pre>{{ content }}</pre>
        </v-row> -->
    </v-container>
</template>
<script>
import { cl } from '~/plugins/global.js'
import prependRoute from '~/util/prependRoute'
import CtaLinks from '~/components/CtaLinks'
export default {
    name: 'SuperHero',
    components: {
        CtaLinks,
    },
    props: {
        content: {
            type: Object,
            default: null,
        },
        context: {
            type: String,
            default: '',
        },
    },
    computed: {
        image1() {
            return (
                this.content[this.$i18n.locale][
                    `heroImage1${this.$i18n.locale}`
                ] || this.content.en.heroImage1en
            )
        },
        image2() {
            return (
                this.content[this.$i18n.locale][
                    `heroImage2${this.$i18n.locale}`
                ] || this.content.en.heroImage2en
            )
        },
        image3() {
            return (
                this.content[this.$i18n.locale][
                    `heroImage3${this.$i18n.locale}`
                ] || this.content.en.heroImage3en
            )
        },
    },
    methods: {
        calcTo(i) {
            // return '/'
            if (i.ctaLinks && i.ctaLinks.length > 0) {
                const link = i.ctaLinks[0]
                const locale = this.$i18n.locale
                const type = link.ctaLinkURL ? link.ctaLinkURL._type : 'page'
                const slug = link.ctaLinkURL ? link.ctaLinkURL.slug : '/'
                const calc = prependRoute({ type, slug })
                const partial =
                    link.ctaLinkPartial &&
                    link.ctaLinkPartial[locale] &&
                    link.ctaLinkPartial &&
                    link.ctaLinkPartial[locale] !== ''
                        ? `${link.ctaLinkPartial[locale]}/`
                        : ''
                const anchor =
                    link.ctaLinkAnchor &&
                    link.ctaLinkAnchor[locale] &&
                    link.ctaLinkAnchor[locale] !== ''
                        ? `#${link.ctaLinkAnchor[locale]}`
                        : ''
                return calc && calc[locale]
                    ? `${calc[locale]}${partial}${anchor}`
                    : `#`
            }
        },
        calcImageInlineStyle(img) {
            // background-image: url("photographer.jpg"); /* The image used */
            // background-color: #cccccc; /* Used if the image is unavailable */ height: 500px;
            // /* You must set a specified height */ background-position: center; /* Center the
            // image */ background-repeat: no-repeat; /* Do not repeat the image */
            // background-size: cover; /* Resize the background image to cover the entire
            // container */
            if (!img) {
                return ''
            }
            const imageUrl = this.$img(`${process.env.ASSET_HOSTNAME}${
                img?.selectedImage?.asset?.originalFilename ||
                'c3controls-icon.jpg'
            }?fit=scale`, {format: 'webp'})
            // const imageUrl = `${process.env.ASSET_HOSTNAME}${
            //     img?.selectedImage?.asset?.originalFilename ||
            //     'c3controls-icon.jpg'
            // }?fit=scale`
            const imageSize = img.size || 'cover'
            let focus = 'center center'
            if (img.focus === 'topLeft') {
                focus = 'left top'
            } else if (img.focus === 'topRight') {
                focus = 'right top'
            } else if (img.focus === 'bottomRight') {
                focus = 'right bottom'
            } else if (img.focus === 'bottomLeft') {
                focus = 'left bottom'
            }
            return `background-image:url(${imageUrl});background-size:${imageSize};background-repeat:no-repeat;background-position: ${focus};`
        },
        getctaAlignment() {},
    },
}
</script>
